import { message } from 'antd';
import IHint from '@imgs/icons/hint.svg';
import IError from '@imgs/icons/error.svg';
import ISuccess from '@imgs/icons/success.svg';
import IInfo from '@imgs/icons/information.svg';
import React from 'react';
import styles from './index.less';

export function MessageSuccess(
  content: string | React.ReactNode,
  duration?: number,
  onClose?: () => void
) {
  return message.success({
    className: styles['msg-success'],
    icon: <ISuccess className='anticon svg-size-18'></ISuccess>,
    content,
    duration,
    onClose,
  });
}

export function MessageError(
  content: string | React.ReactNode,
  duration?: number,
  onClose?: () => void
) {
  // fix：有不少地方传入了 undefined 和 null 导致报错
  if (content === undefined || content === null) {
    return null;
  }

  return message.error({
    className: styles['msg-error'],
    icon: <IError className='anticon svg-size-18'></IError>,
    content,
    duration,
    onClose,
  });
}

export function MessageWarning(
  content: string | React.ReactNode,
  duration?: number,
  onClose?: () => void
) {
  return message.warning({
    className: styles['msg-wraning'],
    icon: <IHint className='anticon svg-size-18'></IHint>,
    content,
    duration,
    onClose,
  });
}

export function MessageInfo(
  content: string | React.ReactNode,
  duration?: number,
  onClose?: () => void
) {
  return message.info({
    className: styles['msg-info'],
    icon: <IInfo className='anticon svg-size-18'></IInfo>,
    content,
    duration,
    onClose,
  });
}
